import api from './api'

export const serialService = {
  getAvailable: (productId?: number | string) =>
    api.get('/serials/available', { params: productId ? { product: productId } : undefined }),

  getById: (id: number | string) =>
    api.get(`/serials/${id}`),

  createBulk: (productId: number, serials: string[]) =>
    api.post('/serials/bulk', { product_id: productId, serials }),
}
